import angular from 'angular';
import template from './template.html';

export class Footer {
    /* @ngInject */
    constructor() {
        this.currentYear = (new Date()).getFullYear();
        this.appVersion = window.VERSION;
        this.appBuildDate = window.BUILD_DATE;
    }
}

export const FooterConfiguration = {
    template,
    controller: Footer,
    controllerAs: 'footerCtrl'
};

angular.module('TALENYA-FE').component('footer', FooterConfiguration);